'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDefaultType, getDisplayName, getModuleIcon, getIsModuleEditable, getIsGlobalModuleGroupOrPartial, getModuleById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsAdvancedModuleWithoutAccess, getModuleHasPaymentsFieldWithoutAccess, getModuleHasPersonalizationTokensWithoutAccess } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsModuleStyleable } from 'ContentEditorUI/redux/selectors/styleSelectors';
import { BaseResponsiveToolbar, buildActionsForModuleOutsideContainer } from './BaseResponsiveToolbar';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { shouldShowEditModuleOnSelected } from 'InpageEditorUI/lib/toolbarUtils';
import { getShouldNotOpenSidebarOnEditClick } from './helpers';
import { getResponsiveToolbarPinLocation } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  let newProps = {};
  if (ownProps.id) {
    const module = getModuleById(state, ownProps.id);
    newProps = {
      moduleType: getDefaultType(state, ownProps.id),
      moduleIcon: getModuleIcon(state, ownProps.id),
      displayName: getDisplayName(state, ownProps.id),
      isEditable: getIsModuleEditable(state, ownProps.id),
      isStyleable: getIsModuleStyleable(state, ownProps.id),
      isGlobal: getIsGlobalModuleGroupOrPartial(state, ownProps.id),
      isAdvancedModuleWithoutAccess: getIsAdvancedModuleWithoutAccess(state, module),
      isPaymentsModuleWithoutAccess: getModuleHasPaymentsFieldWithoutAccess(state, module),
      hasPersonalizationTokenWithoutAccess: getModuleHasPersonalizationTokensWithoutAccess(state, module),
      selectedItemId: getSelectedItemId(state),
      isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state),
      shouldNotOpenSidebarOnEditClick: module && getShouldNotOpenSidebarOnEditClick(state, module)
    };
  }
  newProps.isInNonDefaultBreakpointMode = getIsInNonDefaultBreakpointMode(state);
  return newProps;
};
class ResponsiveToolbarOutsideContainer extends Component {
  render() {
    const {
      id,
      displayName,
      moduleType,
      moduleIcon,
      top,
      left,
      toolbarHeight,
      onHandleMouseDown,
      onDropdownOpenChange,
      responsiveSize,
      dispatch,
      bus,
      isGlobal,
      isEditable,
      isStyleable,
      isInNonDefaultBreakpointMode,
      isFixedPosition,
      isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess,
      selectedItemId,
      isPatagoniaSidebarCollapsed,
      isStaticSectionModule,
      shouldNotOpenSidebarOnEditClick
    } = this.props;
    const showEditModuleOnSelected = shouldShowEditModuleOnSelected({
      isPatagoniaSidebarCollapsed,
      moduleType
    });
    return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
      moduleIcon: moduleIcon,
      pinLocation: getResponsiveToolbarPinLocation(top, toolbarHeight, id === selectedItemId),
      actions: buildActionsForModuleOutsideContainer({
        moduleId: id,
        moduleType,
        isInNonDefaultBreakpointMode,
        dispatch,
        bus,
        isGlobal,
        isEditable,
        isStyleable,
        isAdvancedModuleWithoutAccess,
        isPaymentsModuleWithoutAccess,
        hasPersonalizationTokenWithoutAccess,
        isStaticSectionModule,
        shouldNotOpenSidebarOnEditClick
      }),
      isGlobal: isGlobal,
      onHandleMouseDown: onHandleMouseDown,
      onDropdownOpenChange: onDropdownOpenChange,
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`,
      position: isFixedPosition ? 'fixed' : 'absolute',
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      isDraggable: false,
      isAdvancedModuleWithoutAccess: isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess: isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess: hasPersonalizationTokenWithoutAccess,
      isSelectedItem: id === selectedItemId,
      showEditModuleOnSelected: showEditModuleOnSelected
    });
  }
}
ResponsiveToolbarOutsideContainer.propTypes = {
  id: PropTypes.string,
  moduleType: PropTypes.string,
  moduleIcon: PropTypes.string,
  displayName: PropTypes.string,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  toolbarHeight: PropTypes.number,
  responsiveSize: PropTypes.string.isRequired,
  onHandleMouseDown: PropTypes.func,
  onDropdownOpenChange: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired,
  isGlobal: PropTypes.bool,
  isEditable: PropTypes.bool,
  isStyleable: PropTypes.bool,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isFixedPosition: PropTypes.bool,
  isAdvancedModuleWithoutAccess: PropTypes.bool,
  isPaymentsModuleWithoutAccess: PropTypes.bool,
  hasPersonalizationTokenWithoutAccess: PropTypes.bool,
  selectedItemId: PropTypes.string,
  isPatagoniaSidebarCollapsed: PropTypes.bool,
  isStaticSectionModule: PropTypes.bool,
  shouldNotOpenSidebarOnEditClick: PropTypes.bool
};
ResponsiveToolbarOutsideContainer.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE
};
export default connect(mapStateToProps)(ResponsiveToolbarOutsideContainer);